import { FormGroup } from '@angular/forms';

export class CalculoCartaAnualConfig {

  form: FormGroup;
  multiplicador: number;
  percentual: number;
  formExcedente: FormGroup;
  denominadorPdic: number;

}
